import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import CustomerReport from "../../../containers/modules/report/customer-report";

export default function CustomerReportRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="customer-report"
      index
      element={
        <AccessControl
          name={"Customer Report Show"}
          auth={authUser}
          component={() => <CustomerReport />}
        />
      }
    ></Route>
  );
}
